module.exports = __webpack_public_path__ + "img/wangyixinwen.5db1678f.jpg";